var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 225,
    viewBox: "0 0 164 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.864 84.0243C160.218 84.0243 159.24 84.2435 158.255 85.2878L122.047 123.667V87.8101C122.047 85.3243 120.47 84.0243 118.912 84.0243C118.266 84.0243 117.288 84.2435 116.303 85.2878L80.5602 123.174V87.8101C80.5602 85.3243 78.983 84.0243 77.4249 84.0243C76.7784 84.0243 75.8012 84.2435 74.8154 85.2878L43.0757 118.931V69.8703C43.0757 66.9156 40.8079 64.5117 38.0204 64.5117H5.0553C2.26781 64.5117 0 66.9156 0 69.8703V219.642C0 222.596 2.26781 225 5.0553 225H158.945C161.732 225 164 222.596 164 219.642V87.8101C163.999 85.3243 162.422 84.0243 160.864 84.0243ZM50.3023 189.618H19.3456V160.512H50.3028L50.3023 189.618ZM97.4778 189.618H66.5207V160.512H97.4778V189.618ZM144.654 189.618H113.697V160.512H144.654V189.618Z",
    fill: "#BFA969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsine);
export default __webpack_public_path__ + "static/media/usine.0f2650bd3171d0b154dc9d25acb0d39a.svg";
export { ForwardRef as ReactComponent };